(function () {
  const ease = "0.3s cubic-bezier(0.4, 0, 0.2, 1)";

  function reduced() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function setOpen(item, open) {
    const trigger = item.querySelector("[data-la-drawer-trigger]");
    const panel = item.querySelector("[data-la-drawer-panel]");
    if (!trigger || !panel) return;

    item.classList.toggle("is-open", open);
    trigger.setAttribute("aria-expanded", open ? "true" : "false");

    if (reduced()) {
      panel.style.height = open ? "auto" : "0px";
      return;
    }

    if (open) {
      panel.style.height = panel.scrollHeight + "px";
      const finish = (event) => {
        if (event.propertyName !== "height" || !item.classList.contains("is-open")) return;
        panel.style.height = "auto";
        panel.removeEventListener("transitionend", finish);
      };
      panel.addEventListener("transitionend", finish);
      return;
    }

    panel.style.height = panel.scrollHeight + "px";
    panel.offsetHeight;
    panel.style.height = "0px";
  }

  function bind(root) {
    (root || document).querySelectorAll("[data-la-drawer]").forEach((item) => {
      if (item.dataset.laDrawerReady === "true") return;
      const trigger = item.querySelector("[data-la-drawer-trigger]");
      const panel = item.querySelector("[data-la-drawer-panel]");
      if (!trigger || !panel) return;
      item.dataset.laDrawerReady = "true";
      panel.style.height = "0px";
      panel.style.overflow = "hidden";
      if (!reduced()) panel.style.transition = "height " + ease;
      trigger.addEventListener("click", () => {
        setOpen(item, !item.classList.contains("is-open"));
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => bind(document));
  } else {
    bind(document);
  }

  document.addEventListener("shopify:section:load", (event) => bind(event.target));
})();
